<template>
  <v-container fluid class="px-0 py-0">
    <CommonTable
        :title="title"
        :embedded="embedded"
        :height="height"
        :hide-default-footer="hideDefaultFooter"
        :hide-default-header="hideDefaultHeader"
        :dto-list-query="dtoListQuery"
        :dto-detail-query="dtoDetailQuery"
        :dto-action-command="dtoActionCommand"
        :dto-validate-command="dtoValidateCommand"
        :store-name="storeName"
        :detail-store-name="detailStoreName"
        detailComponentPass="/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentDetail"
        :parent-component="$options.name"
        :main-validator="mainValidator"
        @alternate_action="$emit('alternate_action', $event)"
        :show-select="showSelect"
    >
      <slot name="bar"></slot>
      <template v-slot:bar>
        <slot name="bar"></slot>
      </template>
      <template v-slot:top>
        <slot name="top"></slot>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
      <template v-slot:item.attribute__group="{ item }">
        <span v-if="!!aggregateStore && item.attribute_uid && !!aggregateStore.rootData[item.attribute_uid]">
          {{aggregateStore.rootData[item.attribute_uid].group}}
        </span>
      </template>
      <template v-slot:item.attribute__name="{ item }">
        <span v-if="!!aggregateStore && item.attribute_uid && !!aggregateStore.rootData[item.attribute_uid]">
          {{aggregateStore.rootData[item.attribute_uid].name}}
        </span>
      </template>
      <template v-slot:item.attribute__units_name="{ item }">
        <span v-if="!!aggregateStore && item.attribute_uid && !!aggregateStore.rootData[item.attribute_uid]">
          {{aggregateStore.rootData[item.attribute_uid].units_name}}
        </span>
      </template>
      <template v-slot:item.attribute__shortname="{ item }">
        <span v-if="!!aggregateStore && item.attribute_uid && !!aggregateStore.rootData[item.attribute_uid]">
          {{aggregateStore.rootData[item.attribute_uid].shortname}}
        </span>
      </template>
      <template v-slot:item.component__mpn="{ item }">
        <span v-if="!!aggregateStore && item.attribute_uid && !!aggregateStore.rootData[item.component_uid]">
          {{aggregateStore.rootData[item.component_uid].mpn}}
        </span>
      </template>
      <template v-slot:item.value="{ item }">
        <v-sheet width="200" class="overflow-x-auto">{{item.value}}</v-sheet>
      </template>
      <template v-slot:item.value_text="{ item }">
        <v-sheet width="200" class="overflow-x-auto">{{item.value_text}}</v-sheet>
      </template>
      <template v-slot:footer.prepend>
        <slot name="footer.prepend"></slot>
      </template>
    </CommonTable>
  </v-container>
</template>

<script>
import {useAggregateStore} from '@/store/CommonStore/baseAggregateStore'
import {useTableStore} from "@/components/Common/CommonTable";
import CommonTable from "@/components/Common/CommonTable";
import CoreSpecAttrComponentDetail from "@/components/CoreComponent/SpecAttrComponent/CoreSpecAttrComponentDetail";
import {v4 as uuidv4} from "uuid";
import fileFunction from "@/commonFunction/fileFunction";

export default {
  name: "CoreSpecAttrComponentTable",

  props: {
    embedded: {default: false},
    title: {default: 'SpecAttrComponent'},
    showSelect: {default: true},
    hideDefaultFooter: {default: false},
    hideDefaultHeader: {default: false},
    height: {default: null},
    headers: {default: null},
    storeName: {type: [String], default: 'SpecAttrComponentTable'},
    dtoDetailQuery: {default: 'SpecAttrComponentDetailQueryDTO'},
    detailStoreName: {default: 'SpecAttrComponentDetail'},
    dtoValidateCommand: {type: [String], default: 'SpecAttrComponentValidateCommandDTO'},
    dtoListQuery: {type: [String], default: 'SpecAttrComponentListQueryDTO'},
    dtoActionCommand: {type: [String], default: 'SpecAttrComponentActionCommandDTO'},
    mainValidator: {type: [Boolean], default: false},
  },

  components: {
    CommonTable,
    CoreSpecAttrComponentDetail,
  },

  methods: {
  },


  mounted() {
    this.storeTable = useTableStore(this.storeName)()
    this.aggregateStore = useAggregateStore()
    this.storeTable.dtoDetailQuery = this.dtoDetailQuery
    this.storeTable.dtoListQuery = this.dtoListQuery
    this.storeTable.dtoActionCommand = this.dtoActionCommand
    this.storeTable.options.sortBy = ['attribute__group', 'attribute__name', 'component__mpn']
    this.storeTable.options.sortDesc = [true, true, true]
    this.storeTable.options.itemsPerPage = 100
    this.storeTable.headers = this.headers || [
      {text: 'E', value: 'edit', sortable: false, filterable: true, divider: true, width: 30},
      // {text: 'uid', value: 'uid', sortable: true, filterable: true, divider: true, width: 300},
      {text: 'Manual changed', value: 'manual_changed', sortable: true, filterable: true, divider: true, type: 'bool'},
      {text: 'Attribute group', value: 'attribute__group', sortable: true, filterable: true, divider: true,},
      {text: 'Attribute name', value: 'attribute__name', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'Attribute units name', value: 'attribute__units_name', sortable: true, filterable: true, divider: true,},
      {text: 'Attribute shortname', value: 'attribute__shortname', sortable: true, filterable: true, divider: true,},
      {text: 'Article MPN', value: 'component__mpn', sortable: true, filterable: true, divider: true, width: 150},
      {text: 'Units name', value: 'units_name', sortable: true, filterable: true, divider: true,},
      {text: 'Units', value: 'units', sortable: true, divider: true},
      {text: 'units_symbol', value: 'units_symbol', sortable: true, divider: true, width: 60},
      {text: 'Display value', value: 'display_value', sortable: true, divider: true, width: 60},
      {text: 'value', value: 'value', sortable: true, divider: true, width: 100},
      {text: 'value_type', value: 'value_type', sortable: true, divider: true, width: 60},
      {text: 'si_value', value: 'si_value', sortable: true, divider: true, width: 60},
      {text: 'value_integer', value: 'value_integer', sortable: true, divider: true, width: 60},
      {text: 'value_float', value: 'value_float', sortable: true, divider: true, width: 60},
      {text: 'value_text', value: 'value_text', sortable: true, divider: true, width: 100},
      {text: 'edited_by', value: 'edited_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'edited_on', value: 'edited_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: 'created_by', value: 'created_by_uid', sortable: true, filterable: true, divider: true},
      {text: 'created_on', value: 'created_on', sortable: true, filterable: true, divider: true, type: 'datetime'},
      {text: '', value: 'is_saved', sortable: false, filterable: true, divider: true, width: 30},
    ]
  },

  data() {
    return {
      storeTable: null,
      aggregateStore: null,
    }
  },
}
</script>

<style scoped>

</style>


<i18n src="@/components/CoreComponent/locales.json">
</i18n>